import React, {useEffect, useRef, useState} from 'react';
import {arrayToObject, isEmpty} from 'utils/Utils';
import DevicesList from './DevicesList';
import LoadCellDetails from './LoadCellDetails';
import VFDDetails from './VFDDetails';

export default function DevicesConfig({currentConfiguration, ...props}) {
    const isMounted = useRef(false);
    const [showLoadCellDetails, setShowLoadCellDetails] = useState(false);
    const [showVfdDetails, setShowVfdDetails] = useState(false);
    const [loadCell, setLoadCell] = useState({});
    const [vfd, setVfd] = useState({});
    const [hoists, setHoists] = useState({});
    const [motions, setMotions] = useState({});
    const [motors, setMotors] = useState({});

    useEffect(() => {
        isMounted.current = true;
        getHoists();
        getMotions();
        getMotors();
        return () => isMounted.current = false;
    }, [currentConfiguration]);

    const getHoists = () => {
        const config = currentConfiguration?.crane_details?.motion_config;
        if (!isEmpty(config)) {
            setHoists(arrayToObject(config.filter(motion => motion.motion_type === 1)));
        }
        else setHoists({});
    };

    const getMotions = () => {
        const config = currentConfiguration?.crane_details?.motion_config;
        if (!isEmpty(config)) setMotions(arrayToObject(config));
        else setMotions({});
    };

    const getMotors = () => {
        const config = currentConfiguration?.crane_details?.motor_config;
        if (!isEmpty(config)) setMotors(arrayToObject(config, 'uuid'));
        else setMotors({});
    };

    const handleAddLoadCellButtonClick = () => {
        setLoadCell({});
        setShowLoadCellDetails(true);
    };

    const handleAddVfdButtonClick = () => {
        setVfd({});
        setShowVfdDetails(true);
    };

    const handleLoadCellDetailsClick = loadCell => {
        setLoadCell(loadCell);
        setShowLoadCellDetails(true);
    };

    const handleVfdDetailsClick = vfd => {
        setVfd(vfd);
        setShowVfdDetails(true);
    };

    const handleCloseButtonClick = () => {
        setShowLoadCellDetails(false);
        setShowVfdDetails(false);
    };

    if (showLoadCellDetails) return (
        <LoadCellDetails
          {...props}
          currentConfiguration={currentConfiguration}
          motions={hoists}
          loadCell={loadCell}
          onCloseButtonClick={handleCloseButtonClick}
        />
    );

    if (showVfdDetails) return (
        <VFDDetails
          {...props}
          currentConfiguration={currentConfiguration}
          motions={motions}
          vfd={vfd}
          onCloseButtonClick={handleCloseButtonClick}
        />
    );

    return (
        <DevicesList
          {...props}
          currentConfiguration={currentConfiguration}
          motions={motions}
          motors={motors}
          onLoadCellDetailsClick={handleLoadCellDetailsClick}
          onVfdDetailsClick={handleVfdDetailsClick}
          onAddLoadCellButtonClick={handleAddLoadCellButtonClick}
          onAddVfdButtonClick={handleAddVfdButtonClick}
        />
    );
}
